import React, { useEffect } from "react";
import {
  makeStyles,
  Grid,
  Divider,
  Button,
  Typography,
  Chip,
  Container,
  Box,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { useSelector, useDispatch } from "react-redux";
import { createPurchaseRequest } from "src/redux/actions/purchaseRequest.action";
import { AlertTitle, Alert } from "@material-ui/lab";
import _ from "lodash";
import { hasRole, isAllowed } from "src/utils/Auth";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
  getAllCountries,
} from "src/redux/actions/reference.action";
import Page from "src/components/Page";
import Moment from "moment";
import currencyjs from "currency.js";
import { httpClient } from "src/utils/HttpClient";
import { apiUrl } from "src/Constants";
import moment from "moment";
import StatusLabel from "src/components/StatusLabel";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const PurchaseRequisitionList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    result: {
      countryid,
      fullname,
      companyid,
      currencyid,
      brand_id,
      department_id,
      perid,
      email,
      secureid,
    },
  } = useSelector((state) => state.loginReducer);

  const { purchaseRequests } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const { currencies, countries, allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );

  useEffect(() => {
    dispatch(getAllCountries());
    dispatch(fetchCurrencies(currencyid));
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
  }, []);

  if (purchaseRequests.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition data!</strong>
        </Alert>
      </div>
    );
  }

  const hasEdit = (data, status) => {
    if (data.PR_STATUS !== undefined) {
      return status.some((s) => data.PR_STATUS === s);
    }
  };

  const sumTotalPrice = (value) => {
    let totalAmount = _(value.PR_Ds)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    let totalExpense = _(value.PR_EXPENSEs)
      .groupBy("PRHIDX")
      .map((objs, key) => {
        return _.sumBy(objs, "AMOUNT");
      })
      .value();

    return Number(totalAmount) + Number(totalExpense);
  };

  const sumTotalOriginalPrice = (value) => {
    const totalCosts = _.sumBy(value.PR_Ds, (i) => {
      return i.PRICE * i.QTY;
    });
    return Number(totalCosts);
  };

  const renderLookupBrand = () => {
    if (allBrands.data) {
      let obj = allBrands.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupDepartment = () => {
    if (allDepartments.data) {
      let obj = allDepartments.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  return (
    <Page className={classes.root} title="Purchase Requisition List">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the purchase requisition on the system."
            title="Purchase Requisition"
          />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box>
                {isAllowed(authorizePR.data, ["can_create"]) && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      dispatch(
                        createPurchaseRequest(
                          countryid,
                          fullname,
                          companyid,
                          currencyid,
                          brand_id,
                          department_id,
                          perid,
                          email,
                          secureid,
                          history
                        )
                      );
                    }}
                  >
                    <NoteAddIcon />
                    Create Purchase Requisition
                  </Button>
                )}
              </Box>
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  isLoading={purchaseRequests.isLoading}
                  columns={[
                    {
                      title: "PR NO.",
                      field: "PR_NO",
                    },
                    {
                      title: "Request Date",
                      field: "CREATED_DATE",
                      type: "date",
                      render: (rowData) =>
                        Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                    },
                    { title: "Requester", field: "CREATED_NAME" },
                    {
                      title: "Brand",
                      field: "PR_BRANDID",
                      lookup: renderLookupBrand(),
                    },
                    {
                      title: "Department",
                      field: "PR_DEPARTID",
                      lookup: renderLookupDepartment(),
                    },
                    {
                      title: "Total Original",
                      field: "TOTAL_PRICE",
                      render: (rowData) => {
                        return currencyjs(sumTotalOriginalPrice(rowData), {
                          symbol: "",
                          separator: ",",
                        }).format();
                      },
                      filtering: false,
                      sorting: false,
                    },
                    {
                      title: "Total Budget",
                      field: "TOTAL_PRICE",
                      render: (rowData) => {
                        return currencyjs(sumTotalPrice(rowData), {
                          symbol: "",
                          separator: ",",
                        }).format();
                      },
                      filtering: false,
                      sorting: false,
                    },
                    {
                      title: "Status",
                      field: "PR_STATUS",
                      lookup: {
                        10: "DRAFT",
                        20: "POST",
                        22: "REVIEWED",
                        24: "REJECTED BY REVIEWER",
                        26: "HELD BY REVIEWER",
                        30: "APPROVED",
                        40: "REJECTED BY APPROVER",
                        35: "HELD BY APPROVER",
                        50: "PURCHASING IN PROGRESS",
                        51: "VERIFIED PR",
                        52: "LEGAL MAKES A DECISION",
                        49: "CONTRACT IS REQUIRED",
                        53: "CONTRACT IS NOT REQUIRED",
                        54: "LEGAL IN PROGRESS ",
                        55: "FINAL DRAFT IS DONE AND READY TO SIGN OFF",
                        56: "CONTRACT IS ATTACHED",
                        57: "LEGAL TASK IS COMPLETED ",
                        58: "CONTRACT IS REJECTED",
                        59: "HELD BY LEGAL",
                        80: "REJECTED BY PURCHASER",
                        70: "HELD BY PURCHASER",
                        60: "PURCHASE TASK IS COMPLETED",
                        100: "PO GENERATED",
                      },
                      render: (rowData) => (
                        <StatusLabel status={rowData.PR_STATUS} />
                      ),
                    },
                    {
                      title: "REFER",
                      field: "REF_PR_NO",
                      render: (rowData) => {
                        if (rowData.PR_TYPE === 2) {
                          return rowData.REF_PR_NO;
                        } else {
                          if (rowData.REF_COUNTRYID && countries.data) {
                            // eslint-disable-next-line array-callback-return
                            let country = countries.data.map((i) => {
                              if (i.REF_ID === rowData.REF_COUNTRYID) {
                                return i.REF_NAME;
                              }
                            });
                            return country;
                          }
                        }
                      },
                      // filtering: false,
                      sorting: false,
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = ``;
                      if (hasRole(authorizePR.data, ["staff", "super-admin"])) {
                        url = `${apiUrl}/purchase-request/staff/${countryid}?`;
                      } else {
                        url = `${apiUrl}/purchase-request/user/${brand_id}/${department_id}/${countryid}?`;
                      }
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + query.page;
                      url += "&search=" + query.search;

                      if (query.filters.length) {
                        query.filters.map(({ column, value }) => {
                          if (column.field === "CREATED_DATE") {
                            value = moment(value).format("YYYY-MM-DD");
                          }
                          url += `&${column.field}=${value}`;
                        });
                      }

                      if (query.orderBy) {
                        url += `&orderby=${query.orderBy.field},${query.orderDirection}`;
                      }

                      httpClient.get(url).then(({ data }) => {
                        resolve({
                          data: data.rows,
                          page: query.page,
                          totalCount: data.count,
                        });
                      });
                    })
                  }
                  actions={[
                    (rowData) => ({
                      icon: "comment",
                      tooltip: "Purchase Requisition Comment",
                      hidden: Boolean(
                        rowData.PR_STATUS === 10 ||
                          rowData.PR_STATUS === 20 ||
                          rowData.PR_STATUS === 30
                      ),
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(
                          `purchase-requisition-remark/${rowData.PRHIDX}/${rowData.PR_NO}`
                        );
                      },
                    }),
                    (rowData) => ({
                      icon: "edit",
                      tooltip: "View Purchase Requisition",
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(
                          `edit-purchase-requisition/${rowData.PRHIDX}`
                        );
                      },
                    }),
                  ]}
                  detailPanel={[
                    (rowData) => ({
                      icon: "storage",
                      tooltip: "Detail of the PO generated",
                      disabled: Boolean(rowData.PR_STATUS < 100),
                      render: (rowData) => {
                        return (
                          <Card>
                            <CardContent>
                              <MaterialTable
                                title
                                columns={[
                                  {
                                    title: "PO NO.",
                                    field: "PO_NO",
                                  },
                                  {
                                    title: "ITEM",
                                    field: "ITEMS_DETAIL",
                                  },
                                  {
                                    title: "TYPE",
                                    field: "PO_TYPE",
                                    render: (rowData) => {
                                      return rowData.PO_TYPE === 1
                                        ? "(PO Generate)"
                                        : "(Not Generate)";
                                    },
                                  },
                                  {
                                    title: "CREATE DATE",
                                    field: "CREATED_AT",
                                    type: "date",
                                    render: (rowData) =>
                                      Moment(rowData.CREATED_AT).format(
                                        "DD-MMM-YY"
                                      ),
                                  },
                                ]}
                                data={rowData.PR_D_JOBs}
                                options={{
                                  filtering: false,
                                }}
                              />
                            </CardContent>
                          </Card>
                        );
                      },
                    }),
                  ]}
                  options={{
                    filtering: true,
                    search: true,
                    // showFirstLastPageButtons: false,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default PurchaseRequisitionList;
